import { useQuery } from '@tanstack/react-query';
import { apiJson } from '@lib/apiClient';
import type { QueueItem } from '@/types/intake';

export interface QueueTotals {
  arrived: number;
  resulted: number;
  pending: number;
  remaining: number;
}

export interface QueueResponse {
  enabled: boolean;
  count: number;
  items: QueueItem[];
  totals?: QueueTotals;
}

/** Poll the eligible-resulting queue (arrived + unresulted + not-pending kits) for a campaign. */
export function useEligibleQueue(campaign: string) {
  return useQuery({
    queryKey: ['intake-queue', campaign],
    queryFn: () => apiJson<QueueResponse>(`/api/intake/queue?campaign=${encodeURIComponent(campaign)}`),
    refetchInterval: 60_000,
    refetchOnMount: 'always', // entering the Bench pulls the current queue immediately, not a stale cache
  });
}
